import { useEffect, useState } from "react"
import { useParams } from "react-router";
import { getAxiosInstance } from "../../../api";
import { toast } from "react-toastify";



export const useShareProfile = () => {
    let { secret_token } = useParams();
    const [data, setData] = useState({})
    const [urlExpired, setUrlExpired] = useState(false)

    useEffect(() => {
        if (secret_token) {
            getData(secret_token)
        }
    }, [])



    const getData = async (token) => {
        const api = await getAxiosInstance();
        try {
            const res = await api.get(`/share-profile?token=${token}`);

            setData(res?.data?.result)
            setUrlExpired(false)

        }
        catch (err) {
            toast.warning("token invalid!", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setUrlExpired(true)
        }


    }


    return {
        data,
        urlExpired
    }
}